import React, { useState, useEffect, useRef } from "react";
import { Box, Button, Card, CardContent, Checkbox, CircularProgress, FormControlLabel, Grid2 as Grid, Icon, Link, TextField, Typography, useTheme } from "@mui/material";
import { useAuthContext } from "../../contexts";
import { VForm, useVForm } from "../../forms";
import CookieService from "../../services/autenticacao/CookieService";
import { } from "../../../pages";
import { useNavigate, useParams } from "react-router-dom";
import { DialogMensagem, IDadosModal } from "../modal/DialogMensagem";
import { IDadosRetorno, IDadosLogin, AuthService, Ilogin } from "../../services/autenticacao/AuthService";
import { UtilidadeService } from "../../services/api/utilidades/UtilidadesService";
import logo from "../../../img/fantasygm_logo.png";
import { JoinFullSharp } from "@mui/icons-material";

// const loginSchema = yup.object().shape({
//     usuario: yup.string().required(),
//     senha: yup.string().required().min(5),
// });

type Props = {
    children?: React.ReactNode,
    handleChangeTabs: any
};

export const Login: React.FC<Props> = ({ handleChangeTabs, children }) => {
    const { formRef } = useVForm();
    const { isAuthenticated, handleLogin, logout } = useAuthContext();
    const [isLoading, setIsLoading] = useState(false)
    const theme = useTheme();
    const preventDefaut = () => { }
    const pathname = window.location.pathname;
    const [usuario, setUsuario] = useState("");
    const [senha, setSenha] = useState("");
    const [lembrarme, setLembrarme] = useState(false);    
    const [usuarioError, setUsuarioError] = useState("");
    const [senhaError, setSenhaError] = useState("");
    const [loginError, setLoginError] = useState("");
    const navigate = useNavigate();
    const [redirecionar, setRedirecionar] = useState("0");
    const [showModalMensagem, setShowModalMensagem] = useState(false);
    const [possuiErrors, setPossuiErrors] = useState(false);
    const [dadosModal, setDadosModal] = useState<IDadosModal>({
        acao: false,
        label: "",
        tipo: "error",
        mensagem: "Sessão Expirada!",
        display: "none",
        titulo: "Atenção"
    });

    const [errors, setErrors] = useState({
        error: false,
        usuarioRef: "",
        senhaRef: "",
        mensagemErro: ""
    });

    const usuarioRef = useRef<null | HTMLElement>(null);
    const senhaRef = useRef<null | HTMLElement>(null);

    useEffect(() => {
        const fetchData = async () => {
            const obj = CookieService.get("access_user");
            if (obj) {
                var dt = obj.dtExpiracao ? obj.dtExpiracao : new Date();
                if (dt <= new Date()) {
                    setShowModalMensagem(true);
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "info",
                        mensagem: "Sessão expirada!",
                        display: "none",
                        titulo: "Atenção"
                    });
                    logout();
                    setRedirecionar("/login");
                    return;
                }
                if (obj.lembrarme) {
                    if (isAuthenticated) {
                        localStorage.removeItem("@codigoLiga");
                        <>{children}</>
                    }
                    else {
                        logout();
                        setShowModalMensagem(true);
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        setRedirecionar("/login");
                        return;
                    }
                }
            }
            else {
                logout();
                navigate("/login");
                return;
            }
        }
        fetchData();
    }, [isAuthenticated]);


    async function verificarCamposObrigatorios(dados: IDadosLogin) {
        const errors: any = {};
        let err = false;

        if (dados.usuario === "" || dados.usuario === undefined) {
            usuarioRef.current?.focus();
            errors.usuarioRef = "Campo obrigatório";
            errors.error = err = true;

        };

        if (dados.senha === "" || dados.senha === undefined) {
            senhaRef.current?.focus();
            errors.senhaRef = "Campo obrigatório";
            errors.error = err = true;

        };


        setPossuiErrors(err);
        return errors;
    };

    async function validacaoDosValores(valores: IDadosLogin) {

        let objError = await verificarCamposObrigatorios(valores);
        setErrors(objError);
        return objError.error;
    }

    const handleSubmit = async () => {        
        setIsLoading(true);
        const dados: IDadosLogin = {
            usuario: usuario,
            senha: senha,
            lembrarme: lembrarme,
            email: "",
            ip: ""
        }

        let possuiErro = await validacaoDosValores(dados);
        if (possuiErro) {
            setShowModalMensagem(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Existe campo obrigatório não preenchido ou valor inválido. Favor verificar!",
                display: "none",
                titulo: "Atenção"
            });
            setIsLoading(false);
            return;
        }
        else {
            await AuthService.login(dados)
                .then((response) => {
                    handleLogin(response.dado);                                
                    setIsLoading(false);
                    setUsuario("");
                    setSenha("");
                    setLembrarme(false);
                    
                    localStorage.removeItem("@codigoLiga");
                    CookieService.set("Logout", "False", {});
                    if (pathname !== "/login") {
                        navigate(encodeURI(`${pathname}`))
                    }
                    else {                        
                        let ligaFavorita = response.dado.codigo_Liga_Favorito !== undefined && response.dado.codigo_Liga_Favorito !== null ? UtilidadeService.crypt(response.dado.codigo_Liga_Favorito?.toString()) : ""
                        if (ligaFavorita !== "") {
                            localStorage.setItem("@codigoLiga", ligaFavorita?.toString());
                            navigate(encodeURI(`/usuario/liga/${ligaFavorita}`))
                            return;
                        }
                        navigate(encodeURI(`/usuario/liga`))
                    }
                }).catch((errors) => {                    
                    setIsLoading(false);
                    if (errors.response !== undefined && errors.response.data !== undefined && !errors.response.data.processado) {
                        setSenhaError(errors.response.data.mensagem);
                    }
                    navigate("/login");
                });
        }
    };

    const handleChange = (event: { target: { name: any; checked: any; }; }) => {
        setLembrarme(event.target.checked);
    };

    const toggleModalMensagem = () => {
        setShowModalMensagem(modalVisivel => !modalVisivel);
        if (redirecionar !== "") {
            redirecionar.length === 1 ? navigate(0) : navigate(redirecionar);
        }

    };

    return (
        <>
            {showModalMensagem && <DialogMensagem dados={dadosModal} isModalVisible={showModalMensagem} onBackClickClose={toggleModalMensagem} />}
            {isAuthenticated ? <>{children}</> :
                <Box display={!isAuthenticated ? "flex" : "none"} alignItems="center" justifyContent="center" >
                    <VForm ref={formRef} onSubmit={handleSubmit} style={{ width: UtilidadeService.isMobile() ? "280px" : "396px" }}>
                        <Card sx={{ boxShadow: "none" }}>
                            <CardContent>
                                <Box display="flex" flexDirection="column" gap={1} width={UtilidadeService.isMobile() ? 250 : 350}>
                                    <Grid container display="flex" alignItems="center" justifyContent="center">

                                        <Grid size={12} display="flex" alignItems="center" justifyContent="center" alignSelf={"center"}>
                                            <Typography variant="h6">
                                                <img src={logo} width={175} height={160} alt='logo' />
                                            </Typography>
                                        </Grid>
                                        <Grid size={12} display="flex" alignItems="center" justifyContent="center" alignSelf={"center"}>
                                            <Typography variant="h5" align="center" color={'#fbc02d'} >Bem Vindo!</Typography>
                                        </Grid>
                                    </Grid>
                                    {/* <Grid container size={12} display="flex" alignItems="center" justifyContent="center" >

                                        <Grid size={12} display="flex" alignItems="center" justifyContent="center" alignSelf={"center"}>
                                            <Typography variant="h6" align="center" >                                                
                                                Identifique-se 
                                            </Typography>                                            
                                        </Grid>
                                        <Grid size={12} display="flex" alignItems="center" justifyContent="center" alignSelf={"center"}>
                                            <Icon style={{ display: "flex", alignSelf: "center", color: "#fbc02d" }}>lock</Icon>
                                        </Grid>
                                    </Grid> */}
                                    <TextField
                                        required
                                        fullWidth
                                        label="Usuário"
                                        variant="standard"
                                        disabled={isLoading}
                                        error={!!usuarioError}
                                        helperText={usuarioError}
                                        value={usuario}
                                        onKeyDown={() => setUsuarioError("")}
                                        onChange={(e) => { setUsuario(e.target.value); setErrors({ ...errors, usuarioRef: "" }); }}
                                        ref={usuarioRef as any}

                                    />
                                    {errors.usuarioRef && <span style={{ fontSize: "13px", color: "red" }}>{errors.usuarioRef}</span>}

                                    <TextField
                                        required
                                        fullWidth
                                        label="Senha"
                                        type="password"
                                        variant="standard"
                                        error={!!senhaError || !!loginError}
                                        helperText={senhaError || loginError}
                                        value={senha}
                                        disabled={isLoading}
                                        onKeyDown={() => setSenhaError("")}
                                        onChange={(e) => setSenha(e.target.value)}
                                        ref={senhaRef as any}
                                    />
                                    {errors.senhaRef && <span style={{ fontSize: "13px", color: "red" }}>{errors.senhaRef}</span>}
                                    <Grid container size={12} display="flex" alignItems="center" justifyContent="center">
                                        <Grid size={{ xs: 12, sm: 6 }} >
                                            <FormControlLabel
                                                key="lembrarme"
                                                control={(
                                                    <Checkbox
                                                        name="lembrarme"
                                                        checked={lembrarme}
                                                        onChange={handleChange}
                                                        disabled={isLoading}
                                                    />
                                                )}
                                                label="Lembrar-me"
                                            />
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 6 }} display={"flex"} justifyContent={"end"}>
                                            <Typography margin={'auto'}>
                                                <Link href="#" onClick={() => handleChangeTabs("event", 2)}
                                                //onClick={preventDefaut}
                                                >
                                                    Esqueci a senha
                                                </Link>
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </CardContent>
                            <CardContent>
                                <Box width="100%" display="flex" alignItems="center" justifyContent="center">
                                    <Button
                                        type="submit"
                                        disabled={isLoading}
                                        variant="contained"
                                        endIcon={isLoading ? <CircularProgress size={20} variant="indeterminate" color="inherit" /> : null}
                                    >
                                        Entrar
                                    </Button>
                                </Box>
                            </CardContent>
                        </Card>
                    </VForm>
                </Box >}</>
    );
}


